<template>
  <el-dialog
    :visible.sync="isOpen"
    width="660px"
    :show-close="true"
    class="egl-dialog-elm channel-dialog"
    :title="$locale('global.groupDisplay') + '（' + $locale('global.POS') + '）' + actionText"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :rules="formRules" label-position="top">
      <el-form-item :label="$locale('global.name')" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item :label="$locale('global.order')" prop="sort">
        <el-input v-model.number="form.sort" maxlength="5"></el-input>
      </el-form-item>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$locale('global.btnBackgroundColor') + '（' + $locale('global.POS') + '）'" prop="bgColor">
            <ColorPicker v-model="form.bgColor" @change="clearFormValidate('bgColor')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$locale('global.btnTextColor') + '（' + $locale('global.POS') + '）'" prop="fontColor">
            <ColorPicker v-model="form.fontColor" @change="clearFormValidate('fontColor')" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button class="egl-btn-white" @click="colse_fn">{{$locale("global.cancel")}}</el-button>
          <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import RuleTest from "@/utils/simpleRule.js";
import { positiveNumValidator, hexColorValidator } from "@/utils/formFieldValidator";
import ColorPicker from "@/components/common/ColorPicker";

export default {
  name: "DeviceGroupDialog",
  components: {
    ColorPicker,
  },
  data() {
    return {
      visible: false,
      actionText: "",
      form: this.createForm(),
      rule: {
        name: {
          required: this.$locale("form.plsEnterYourName")
        },
        sort: {
          required: this.$locale("setting.device.warn.orderrequire")
        }
      },
      formRules: {
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
        sort: [{
          required: true,
          message: this.$locale("setting.device.warn.orderrequire"),
          trigger: "blur",
        }, {
          validator: positiveNumValidator,
          trigger: "blur",
        }],
        bgColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
        fontColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
      },
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        this.colse_fn();
      },
    }
  },
  methods: {
    colse_fn() {
      this.$refs.form.resetFields();
      this.$emit("closeFn");
    },
    save_fn() {
      let obj = RuleTest(this.rule, this.form);
      let data = {};

      // if (!obj.success) {
      //   this.$alert(obj.message, {
      //     showClose: false
      //   });

      //   return;
      // }

      data = { ...obj.data };

      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit("returnMsg", data);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    createForm: () => {
      return {
        name: "",
        sort: "",
        bgColor: "#FFFFFF",
        fontColor: "#000000"
      };
    },
    clearFormValidate(fieldName) {
      if (fieldName) {
        this.$refs.form.clearValidate(fieldName);
      } else {
        this.$refs.form.clearValidate();
      }
    },
  },
  mounted() {},
  props: {
    action: {
      type: String,
      default: "create"
    },
    actionVisible: {
      type: Boolean,
      default: false
    },
    detailObj: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    actionVisible() {
      let formObj = this.createForm();
      let actionText = "";

      if (this.action == "create") {
        actionText = this.$locale("global.create");
      } else {
        actionText = this.$locale("global.edit");
      }

      if (this.detailObj.id) {
        formObj = { ...formObj, ...this.detailObj };
      }

      this.actionText = actionText;
      this.visible = this.actionVisible;
      this.form = { ...formObj };
    }
  }
};
</script>
